import gql from 'graphql-tag';

export const DEFERRED_FEATURE_QUERY = gql`
  query DeferredFeature(
    $channel: String!
    $countryCodeAsString: String!
    $isBaslAsString: String!
    $isForcedGuest: String!
    $token: String!
    $integrationType: String!
  ) {
    otpLoginContext(token: $token, integrationType: $integrationType) {
      __typename
      context
    }
    elmoExperiment(
      app: "checkoutuinodeweb"
      filters: [
        { key: "Country", value: $countryCodeAsString }
        { key: "Channel", value: $channel }
        { key: "IsBasl", value: $isBaslAsString }
        { key: "IsGuestOnly", value: $isForcedGuest }
      ]
      res: "weasley:deferredFeature:memberAsDefault"
    ) {
      __typename
      treatments {
        __typename
        experimentId
        experimentName
        factors {
          __typename
          key
          value
        }
        treatmentId
        treatmentName
      }
    }
  }
`;
